/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';
import { CostCenterSelectableResourceService } from './cost-center-selectable-resource.service';

export const costCenterSelectableResourceProviders = [
  {
    provide: SelectableResourceService,
    useClass: CostCenterSelectableResourceService,
    multi: true,
  }
];
